import axios from 'axios';
// import { uploadAttachment } from '../../../service/uploadFile';
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useRef, useState } from 'react';
import crossImage from '../../../assets/images/cross.svg'
import { useDispatch } from 'react-redux';
import { createBrandFormActions, onboardFormActions } from '../../../store/createBrandFormState';
import { validationError } from '../../../utils/errors';
import { getImageUrl } from '../../../utils/images';
import { uploadAttachment } from '../../../service/uploadFile';

export const UploadLogo = ({currentDocument, setDocument,setIcon,show, close, docName }) => {
    const dispatch = useDispatch()
    const modalRef = useRef()
   

    const [customDocName, setCustomDocName] = useState("")

    const getAttachment = async (e) => {
        console.log(e);
        
        // Extract file extension
        const fileExt = e.target.files[0].name.split(".").pop().toLowerCase() || "txt";
        console.log("fileExt", fileExt);
        
        // Validate file size (50MB max)
        if (e.target.files[0].size > 50000000) {
            return validationError("File size not allowed", "You can only upload files under 50MB.");
        }
    
        // Validate unsupported file extensions
        if (fileExt === "pdf" || fileExt === "docx") {
            return validationError("Unsupported Media", "Only image files (e.g., PNG, JPG) are supported.");
        }
    
        const file = e.target.files[0];
    
        // Read the file to check dimensions
        const fileReader = new FileReader();
        fileReader.onload = function(event) {
            const image = new Image();
            image.onload = function() {
                const width = image.width;
                const height = image.height;
    
                // Validate image dimensions (512px by 512px)
                if (width !== 512 || height !== 512) {
                    return validationError("Invalid Dimensions", "Only images of size 512x512 pixels are allowed.");
                }
    
                // If dimensions are valid, proceed with the rest of the logic
                file.isUploading = true;
                file.cancelToken = axios.CancelToken.source();
                const path = (window.URL || window.webkitURL).createObjectURL(file);
                file.path = path;
                console.log("file", file);
                setIcon(true)
                // Set document state
                setDocument({
                    file: file,
                    isUploading: false,
                    isUploaded: false,
                    progress: 0,
                    url: path,
                    name: file.name
                });
            };
    
            // Load the image from the file URL
            image.src = event.target.result;
        };
    
        // Read the file as a data URL
        fileReader.readAsDataURL(file);
    };
    

    const removeAttachment = () => {
        setDocument({
            isUploading: false,
            isUploaded: false,
            progress: 0,
            url: "",
        });
    }

    const uploadDoc = async () => {
        const file = currentDocument.file
        const fileExt = file.name.split(".")[1].toLowerCase() || "txt";
        const uniqueName = uuidv4() + "." + fileExt
        const fileData = new FormData();
        fileData.append("file", new File([currentDocument.file], uniqueName));
        const response = await uploadAttachment(
            fileData,
            setDocument,
            file.cancelToken
        );
        if (response.data) {
            if (docName !== "") {
                dispatch(createBrandFormActions.updateMandatoryAndOptionalDoc({ id: docName, url: currentDocument.url, docId: response.data.id }))
            } else {
                dispatch(createBrandFormActions.addBrandLogo({ id: response.data.id, url: currentDocument.url, docId: response.data.id, name: customDocName }))
            }
            close()
        }

        console.log("response Data",response)
    }

    useEffect(() => {
        if (show) {
            document.getElementsByTagName("body")?.[0]?.classList.add("modal-open")
            setTimeout(() => {
                document.getElementById("upload-document")?.classList.add("show")
            }, 100)
        }
        else {
            document.getElementsByTagName("body")?.[0]?.classList.remove("modal-open")
        }

        // setDocument({
        //     file: "",
        //     isUploading: false,
        //     isUploaded: false,
        //     progress: 0,
        //     url: "",
        //     name: ""
        // })

    }, [show])

    useEffect(() => {
        const handler = (event) => {
            if (!modalRef.current) {
                return;
            }
            if (modalRef.current == event.target) {
                close();
            }
        };
        document.addEventListener("click", handler, true);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);

    return (
        show ?
            <div>
                <div
                    className="modal fade"
                    id="upload-document"
                    aria-modal="true"
                    role="dialog"
                    style={{ display: "block" }}
                    ref={modalRef}
                >
                    <div className="modal-dialog">
                        <div className="modal-content rounded-15">
                            <div className="modal-body px-70 py-40">
                                <p className="mb-1 font-20 font-weight-800">
                                   Upload logo
                                </p>
                                <p className="opacity-70">
                                Please upload logo.
                                </p>
                                <div className="row form-default">
                                    <div className="col-12 col-md-12">
                                        {currentDocument.url == "" && <div className="form-group fileDragDrop mt-3 mb-50">
                                            <div className="inputFile">
                                                <input type="file" className="form-control" onChange={getAttachment} onClick={e => e.target.value = null}  accept=".png,.jpg,.jpeg"/>
                                            </div>
                                            <p className="font-weight-600 broken-top-70 text-center">
                                                Drag &amp; drop files or{" "}
                                                <span className="text-light-default">browse</span>
                                            </p>
                                            <p className="font-10 broken-top-10 text-center">
                                                Supported formates: PNG only
                                            </p>
                                        </div>
                                        }

                                        {currentDocument.url != "" &&
                                            <div>{console.log("currentDocument",currentDocument)} <img className='mt-3 mb-50' style={{ border: "none", width: "100%" }} src={currentDocument.url} />

                                                <div className="form-group form-file position-relative">
                                                    <label className="text-dark opacity-70">Upload</label>
                                                    <span className="icon-cross" onClick={removeAttachment}>
                                                        <img src={getImageUrl("cross.svg")} alt="img" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        defaultValue={currentDocument.name}
                                                        disabled
                                                    />
                                                    {currentDocument.isUploading && <div className="progress mt-1">
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{ width: `${currentDocument.progress}%` }}
                                                            aria-valuenow={60}
                                                            aria-valuemin={0}
                                                            aria-valuemax={100}
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                                {/* {docName == "" && <div className="form-group mb-4">
                                                    <label>Document name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter the name of the document"
                                                        onChange={(e) => setCustomDocName(e.target.value)}
                                                    />
                                                </div>
                                                } */}
                                                <button type="button" className="btn btn-default w-100" onClick={()=> uploadDoc()} disabled={currentDocument.isUploading ? true : false}>
                                                    {currentDocument.isUploading ? "Uploading" : "Use this logo"}
                                                </button>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`modal-backdrop fade ${show && "show"}`} />

            </div> : <div></div>

    )
}